/**
 * @todo Удалить директорию
 * @description Данный функционал появился в задаче CD-162876, будет удалён в задаче CD-162894
 */

import { IconHighDemand16 } from '@cian/ui-kit';

import { FC } from 'react';

import { Link } from 'shared/components/InteractiveTypography';

import { WrapElementsSpacer } from '../WrapElementsSpacer';

import styles from './ToLegacyListing.css';

type ToLegacyListingProps = {
  url: string;
  onClick(): void;
  trackLinkClick(): void;
};

export const ToLegacyListing: FC<ToLegacyListingProps> = props => {
  const { url, onClick, trackLinkClick } = props;

  return (
    <div className={styles['container']}>
      <WrapElementsSpacer horizontalSpace={8} verticalSpace={8} wrapItems={false}>
        <IconHighDemand16 color="warning_100" />
        Мы обновили внешний вид поиска, но оставили возможность вернуться в старый дизайн.
      </WrapElementsSpacer>
      <Link
        behaviour="hover_primary_to_primary_hover"
        href={url}
        target="_self"
        track={trackLinkClick}
        onClick={onClick}
      >
        Вернуться к старому виду
      </Link>
    </div>
  );
};
